export default __webpack_public_path__ + "static/media/carousel-image4-mobile.png.webp";